// project imports
import ACTION_TYPE from 'components/../redux/actions/actionTypes';

// action - state management

const initialState = {
    energyValues: {},
    generalSettings: {},
    levelOptions: {},
    levelSettings: {},
    selectedDashboards: {},
    unitsValues: {}
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const settingsReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case ACTION_TYPE.INIT_SETTINGS:
            return initialState;
        case ACTION_TYPE.LOAD_SETTINGS:
            return {
                ...action.data
            };
        case ACTION_TYPE.UPDATE_SETTINGS:
            return {
                ...state,
                ...action.data
            };
        case ACTION_TYPE.LOAD_SETTINGS_FAILED:
            return state;
        case ACTION_TYPE.AUTH_LOGOUT:
            return initialState;
        default:
            return state;
    }
};

export default settingsReducer;
